"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceForbiddenCharacters = void 0;
// Delete all non-alpha numeric characters : see https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-keys.html
const replaceForbiddenCharacters = (fileFullName) => fileFullName.replace(new RegExp("[^a-zA-Z0-9.-]", "g"), "_");
exports.replaceForbiddenCharacters = replaceForbiddenCharacters;
